import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './router'; // MOD
import reportWebVitals from './reportWebVitals';
 
import 'ui/theme.css'; 
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer } from 'react-toastify';
import { CoreState } from './context/CoreContext'

const app = (
  <React.StrictMode>
    <CoreState>
      <App />
      <ToastContainer />
    </CoreState>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');

// Pré-renderização: quando a página chega "pronta" do servidor (uma foto
// salva no build), reaproveitamos esse conteúdo (hidratar) em vez de
// remontar do zero — assim o usuário vê tudo na hora e o Google/IA também.
//
// A foto carrega uma marca <meta name="x-prerender-path"> dizendo a QUAL
// rota ela pertence. Só hidratamos quando a marca bate exatamente com a
// página atual; em qualquer outro caso, limpamos e montamos normalmente.
// Isso garante que as páginas de login/área do assinante continuem 100%
// como antes, sem nenhum conflito.
const snapshotMeta = document.querySelector('meta[name="x-prerender-path"]');
const norm = (p) => (p || '').replace(/\/+$/, '') || '/';
const currentPath = norm(window.location.pathname);
const snapshotPath = snapshotMeta ? norm(snapshotMeta.getAttribute('content')) : null;

if (rootElement.hasChildNodes() && snapshotPath === currentPath) {
  ReactDOM.hydrate(app, rootElement);
} else {
  if (rootElement.hasChildNodes()) { rootElement.innerHTML = ''; }
  ReactDOM.render(app, rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
